import { TeamType } from "@redotech/account-common/team-type";

interface LogoutTeam {
  storeUrl: string;
  teamType?: TeamType;
}

export function getLogoutDestination({
  deviceAuthToken,
  origin,
  team,
}: {
  deviceAuthToken: string | undefined;
  origin: string;
  team: LogoutTeam;
}) {
  if (deviceAuthToken || team.teamType === TeamType.FulfillmentService) {
    return origin + "/login/add";
  }

  return `https://${team.storeUrl}/admin`;
}
